<template>
  <nav class="sidebar bg-light">

    <!-- ✅ BRAND -->
    <div class="sidebar-brand">
      Fitmotivation.com
    </div>

    <div class="sidebar-inner">

      <!-- Main -->
      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/">Dashboard</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click="signOut">Sign out</a>
        </li>
      </ul>

      <div class="sidebar-heading">Content</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/banners">Banners</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/blogs">Blogs</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/instructors">Instructors</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/notes">Notes</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/quizzes">Quizzes</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/testimonials">Testimonials</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/tips">Tips</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/videos">Videos</router-link>
        </li>
      </ul>

      <div class="sidebar-heading">People</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/users">Customers</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/organizations">Organizations</router-link>
        </li>
      </ul>

      <div class="sidebar-heading">Commerce</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/purchases">Purchases</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://store.fitmotivation.com/" target="_blank">
            Open Store
          </a>
        </li>
      </ul>

      <div class="sidebar-heading">Categories</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/video-categories">
            Videos
          </router-link>
        </li>
      </ul>

      <div class="sidebar-heading">Utilities</div>

      <ul class="nav flex-column">
        <li class="nav-item">
          <router-link class="nav-link" to="/cloudfront-cdn-link-generator">
            Cloudfront URL tool
          </router-link>
        </li>
      </ul>

    </div>

  </nav>
</template>
<script>
import AccountService from "../services/AccountService";

export default {
  methods: {
    signOut: function () {
      AccountService.deleteSession();
      window.location.href = "/login";
    },
  },

  created: function () {
    AccountService.validateSession()
      .then((response) => {
        if (response.data.enabled === 0) {
          this.signOut();
        }
      })
      .catch((err) => {
        this.signOut();
      });
  },
};
</script>
<style scoped>
/* ===== VISUAL ONLY (no layout/sticky here) ===== */

.sidebar {
  border-right: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

/* ✅ BRAND */
.sidebar-brand {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.75rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0.5rem;
}

/* spacing wrapper */
.sidebar-inner {
  padding-bottom: 2rem;
}

/* compact nav */
.nav {
  margin: 0;
  padding: 0;
}

.nav-item {
  margin: 0;
}

.nav-link {
  color: #333;
  padding: 0.2rem 0.6rem;
  font-size: 0.78rem;
  line-height: 1.2;
  border-radius: 4px;
  margin: 0 6px;
}

.nav-link:hover {
  background-color: rgba(13, 110, 253, 0.08);
  color: var(--bs-primary);
}

.nav-link.router-link-active {
  background-color: rgba(13, 110, 253, 0.12);
  color: var(--bs-primary);
  font-weight: 600;
}

/* section headers */
.sidebar-heading {
  font-size: 0.65rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6c757d;
  margin: 0.75rem 0 0.25rem;
  padding-left: 0.75rem;
}

/* subtle scroll hint (safe) */
.sidebar::before,
.sidebar::after {
  content: "";
  position: sticky;
  display: block;
  height: 6px;
  z-index: 2;
}

.sidebar::before {
  top: 0;
  background: linear-gradient(to bottom, #f8f9fa, transparent);
}

.sidebar::after {
  bottom: 0;
  background: linear-gradient(to top, #f8f9fa, transparent);
}
</style>